import { useEffect, useState } from 'react';

export const useInitialLoadingFinished = (selector = '.MuiSkeleton-root'): boolean => {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		const hasSkeletons = () => !!document.querySelector(selector);

		if (!hasSkeletons()) {
			setReady(true);
			return;
		}

		const observer = new MutationObserver(() => {
			if (!hasSkeletons()) {
				setReady(true);
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, [selector]);

	return ready;
};
